import type { JSXInternal } from 'preact/src/jsx'
import { memo } from 'preact/compat'

type Props = JSXInternal.HTMLAttributes<HTMLButtonElement> & {
	backgroundColor?: string
	className?: string
	fullWidth?: boolean
	isLoading?: boolean
	text?: string
	textColor?: string
}

const DropdownButton = memo(
	({
		className,
		disabled = false,
		isLoading = false,
		text,
		textColor,
		backgroundColor,
		children,
		...rest
	}: Props) => (
		<button
			aria-busy={isLoading}
			aria-label='Dropdown menu'
			class='flex h-8 w-[60px] items-center justify-around rounded border border-solid border-black-800 bg-black-900 p-2 px-2 hover:bg-black-800'
			disabled={disabled}
			type='button'
			{...rest}
		>
			{children}
		</button>
	)
)

export { DropdownButton }
